"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueprintTonNetwork = void 0;
const ton_1 = require("ton");
class BlueprintTonNetwork {
    constructor(networkProvider, apiV2Config) {
        this.networkProvider = networkProvider;
        this.oldApi = new ton_1.TonClient({
            endpoint: apiV2Config.apiEndpoint,
            apiKey: apiV2Config.apiKey,
        });
        this.sender = networkProvider.sender();
        this.api = networkProvider.api();
        this.workchain = networkProvider.network() == "testnet" ? 0 : -1;
    }
    open(contract) {
        return this.networkProvider.open(contract);
    }
    isContractDeployed(address) {
        return this.networkProvider.isContractDeployed(address);
    }
    setUp() {
        // nop;
    }
}
exports.BlueprintTonNetwork = BlueprintTonNetwork;
//# sourceMappingURL=BlueprintTonNetwork.js.map